<div class="cyber-checkout-success-page d-flex align-items-center justify-content-center">
  <div class="cyber-success-card text-center">

    <!-- Processing state -->
    @if (state === 'processing') {
      <div class="cyber-state-icon processing">
        <div class="spinner-border text-info" role="status" aria-hidden="true"></div>
      </div>
      <h2 class="cyber-success-title mt-4">Finalising Your Subscription</h2>
      <p class="cyber-success-subtitle">Verifying your payment with Stripe&hellip;</p>
    }

    <!-- Success state -->
    @if (state === 'success') {
      <div class="cyber-state-icon success">
        <i class="bi bi-shield-check" aria-hidden="true"></i>
      </div>
      <h2 class="cyber-success-title mt-4">You&rsquo;re all set!</h2>
      <p class="cyber-success-subtitle">
        Your subscription is now active. Taking you to the next step&hellip;
      </p>
      <div class="progress cyber-progress mt-3" role="progressbar" aria-label="Redirecting">
        <div class="progress-bar progress-bar-striped progress-bar-animated bg-success cyber-progress-bar"></div>
      </div>
    }

    <!-- Error state -->
    @if (state === 'error') {
      <div class="cyber-state-icon error">
        <i class="bi bi-exclamation-triangle" aria-hidden="true"></i>
      </div>
      <h2 class="cyber-success-title mt-4">Verification Incomplete</h2>
      <p class="cyber-success-subtitle">
        We couldn&rsquo;t confirm your payment automatically. Don&rsquo;t worry &mdash;
        if the charge went through, your subscription will be activated within a few minutes via our
        payment processor. Taking you to the next step&hellip;
      </p>
      <p class="cyber-support-note">
        If your plan doesn&rsquo;t update within 10 minutes, please contact
        <a href="mailto:support@scanninja.ai">support&#64;scanninja.ai</a>.
      </p>
    }

  </div>
</div>
